/**
 * Author: Fernando Matamoros Acuna
 */

import React from "react";

//PropTypes
import PropTypes from "prop-types";

//UI Material
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { MenuItem } from "@mui/material";

function Selector({
  value,
  label,
  handleChange,
  content = [],
  width = "150px",
  fullWidth = false,
}) {
  // ==========>Component Functions<==========
  //Function to generate component content
  const generate = () => {
    return content.map((element, index) => {
      return (
        <MenuItem key={`selection-${label}-${index}`} value={index}>
          {element}
        </MenuItem>
      );
    });
  };

  // ==========>Component<==========
  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel id={label}>{label}</InputLabel>
      <Select
        sx={{ width: width, textAlign: "center" }}
        labelId={label}
        id={label}
        value={value}
        label={label}
        onChange={handleChange}
      >
        {generate()}
      </Select>
    </FormControl>
  );
}

// ==========>Component PropTypes<==========
Selector.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
  content: PropTypes.array.isRequired,
  width: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
};

export default Selector;
